<div fxLayout="row"
     fxLayoutAlign="start center"
     class="pointer"
     (mouseenter)="file.isHovered=true"
     (mouseleave)="file.isHovered=false"
     (click)="downloadFile(file.file)">
    @if (Spinner.isShown('downloadFile_' + file.file.id)) {
        <div class="i-24" fxLayoutAlign="center center">
            <ui-kit-spinner [spinnerIds]="'downloadFile_' + file.file.id" [diameter]="16" [strokeWidth]="3"/>
        </div>
    }
    @if (!Spinner.isShown('downloadFile_' + file.file.id)) {
        <ui-kit-svg class="i-24"
                    [name]="file.isHovered ? 'ic_download' : 'ic_document' "/>
    }
    <div class="t4 ml-4"
         [afTextMiddleEllipsis]="file.file.name"
         [class.c-primary-green-800]="file.isHovered"
         [class.c-primary-gray-600]="!file.isHovered">
    </div>
</div>
